import React from 'react';
import { Box, Typography } from '@mui/material';

const SeasonalGuides = () => {
  return (
    <Box sx={{ my: 4 }}>
      <Typography variant="h4" component="h2" gutterBottom>
        Seasonal Guides
      </Typography>
      <Typography variant="body1">
        Coming soon! Check back later for seasonal cleaning guides.
      </Typography>
    </Box>
  );
};

export default SeasonalGuides;
